import { c as _c } from "react/compiler-runtime";
import { dateFromMintNumber, displayedEonNumberFromIndex, displayedEpochNumberFromIndex, displayedEraNumberFromIndex, displayedPeriodNumberFromIndex, displayedSeasonNumberFromIndex, displayedYearNumberFromIndex, getSeasonIndexForDate } from "@/components/meme-calendar/meme-calendar.helpers";
import clsx from "clsx";
import Link from "next/link";
const SECONDARY_PERIOD_CLASS_NAME = "tw-hidden md:tw-flex";
const PERIOD_SEPARATOR_CLASS_NAME = "tw-text-xs tw-font-medium tw-text-iron-700";
export default function MemeCalendarPeriods(t0) {
  const $ = _c(25);
  const {
    id,
    seasonHref,
    showOnlySeasonOnMobile: t1
  } = t0;
  const showOnlySeasonOnMobile = t1 === undefined ? false : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== id || $[1] !== seasonHref || $[2] !== showOnlySeasonOnMobile) {
    const d = dateFromMintNumber(id);
    const idx = getSeasonIndexForDate(d);
    const eon = displayedEonNumberFromIndex(idx);
    const era = displayedEraNumberFromIndex(idx);
    const period = displayedPeriodNumberFromIndex(idx);
    const epoch = displayedEpochNumberFromIndex(idx);
    const year = displayedYearNumberFromIndex(idx);
    const szn = displayedSeasonNumberFromIndex(idx);
    const printSecondaryPeriod = _temp;
    const secondaryPeriods = [{
      label: "YEAR",
      number: year
    }, {
      label: "EPOCH",
      number: epoch
    }, {
      label: "PERIOD",
      number: period
    }, {
      label: "ERA",
      number: era
    }, {
      label: "EON",
      number: eon
    }];
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <span>SZN</span>;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    const seasonContent = <>{t8}<span>{szn}</span></>;
    const secondaryPeriodClassName = showOnlySeasonOnMobile ? SECONDARY_PERIOD_CLASS_NAME : undefined;
    t5 = "tw-flex tw-flex-wrap tw-items-center tw-gap-2";
    t6 = seasonHref ? <Link href={seasonHref} aria-label={`View SZN ${szn} cards`} className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100 tw-no-underline tw-transition-colors hover:tw-border-primary-400 hover:tw-text-primary-300">{seasonContent}</Link> : <span className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900 tw-px-2.5 tw-py-0.5 tw-text-xs tw-font-semibold tw-leading-4 tw-text-iron-100">{seasonContent}</span>;
    let t9;
    if ($[10] !== secondaryPeriodClassName) {
      t9 = clsx(PERIOD_SEPARATOR_CLASS_NAME, secondaryPeriodClassName);
      $[10] = secondaryPeriodClassName;
      $[11] = t9;
    } else {
      t9 = $[11];
    }
    if ($[12] !== t9) {
      t7 = <span aria-hidden="true" className={t9}>/</span>;
      $[12] = t9;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t2 = "Meme calendar position";
    if ($[14] !== secondaryPeriodClassName) {
      t3 = clsx("tw-flex-wrap tw-items-center tw-gap-1.5", secondaryPeriodClassName);
      $[14] = secondaryPeriodClassName;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t4 = secondaryPeriods.map((t10, index) => {
      const {
        label: label_0,
        number: number_0
      } = t10;
      return <span key={label_0} className="tw-inline-flex tw-items-center tw-gap-1.5">{index > 0 && <span aria-hidden="true" className={PERIOD_SEPARATOR_CLASS_NAME}>/</span>}{printSecondaryPeriod(label_0, number_0)}</span>;
    });
    $[0] = id;
    $[1] = seasonHref;
    $[2] = showOnlySeasonOnMobile;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t8 = <span aria-label={t2} className={t3}>{t4}</span>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <span className={t5}>{t6}{t7}{t8}</span>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
}
function _temp(label, number) {
  return <span className="tw-inline-flex tw-items-center tw-gap-1 tw-px-1.5 tw-py-0.5 tw-text-[10.5px] tw-font-medium tw-uppercase tw-tracking-wider tw-text-iron-500"><span>{label}</span><span className="tw-font-semibold tw-text-iron-300">{number}</span></span>;
}